import Layout from '@layout/Index'

export const project = [
  {
    path: '/project',
    component: Layout,
    children: [
      {
        path: 'progress-table',
        component: () => import(/* webpackChunkName: "project-progress-table" */ './pages/ProjectProgressTable.vue'),
        name: '项目进度列表',
        meta: {
          title: '项目进度列表',
        },
      },
      {
        path: 'progress-detail/:id',
        component: () => import(/* webpackChunkName: "project-progress-detail" */ './pages/ProjectProgressDetail.vue'),
        name: '项目进度详情',
        meta: {
          title: '项目进度详情',
        },
      },
      {
        path: 'progress-node-snapshot',
        component: () => import(/* webpackChunkName: "progress-node-snapshot" */ './pages/ProjectProgressSnapshot.vue'),
        name: '项目节点历史记录',
        meta: {
          title: '项目节点历史记录',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/project/project.route.js